import {DatePicker, Form, Input} from 'antd';
import {FormInstance} from 'antd/es/form/Form';
import cn from 'classnames';
import {Moment} from 'moment';
import React, {FC} from 'react';

import {SimpleActionButton} from 'components/form/components';
import {CustomSelect} from 'components/form/inputs/custom-select';
import {ReactComponent as Lock} from 'shared/assets/forms/lock.svg';

import {requiredInputRule} from "../../project-investment-info-item-modal/utils";

import './project-investment-info-service-modal.less';

interface IProjectInvestmentInfoServiceForm {
    serviceName: string;
    reportingDate: Moment;
    reportingYear: number;
    adjNumber: number;
    hasInvestmentProject: string;
}

interface IProjectInvestmentInfoServiceModalFormProps {
    form: FormInstance<IProjectInvestmentInfoServiceForm>;
    handleFinish: () => void;
}

export const ProjectInvestmentInfoServiceModalForm: FC<IProjectInvestmentInfoServiceModalFormProps> = ({
    form,
    handleFinish,
}: IProjectInvestmentInfoServiceModalFormProps) => (
    <Form<IProjectInvestmentInfoServiceForm>
        className={cn('form', 'project-investment-info-service-modal-form')}
        form={form}
        layout="vertical"
        onFinish={handleFinish}
    >
        <div className="form-fields">
            <Form.Item
                style={{width: '100%'}}
                name="serviceName"
                label="Наименование сервиса"
                required
            >
                <Input
                    disabled
                    suffix={<Lock />}
                />
            </Form.Item>

            <div className="project-investment-info-service-fields">
                <div className="project-investment-info-service-fields__title">
                    Дополнительные поля
                </div>
                <div className="project-investment-info-service-fields__content">
                    <Form.Item
                        style={{width: '100%'}}
                        name="reportingDate"
                        label="Дата предоставления сведений"
                        rules={[requiredInputRule()]}
                    >
                        <DatePicker
                            format="DD.MM.YYYY"
                            placeholder="DD.MM.YYYY"
                            style={{width: '100%'}}
                        />
                    </Form.Item>
                    <Form.Item
                        name="reportingYear"
                        label="Отчетный год"
                        style={{width: '100%'}}
                        rules={[requiredInputRule()]}
                    >
                        <Input
                            type="number"
                            placeholder="Введите значение"
                            autoComplete="off"
                            style={{width: '100%'}}
                        />
                    </Form.Item>
                    <Form.Item
                        name="adjNumber"
                        label="Номер корректировки"
                        style={{width: '100%'}}
                        rules={[requiredInputRule()]}
                    >
                        <Input
                            type="number"
                            placeholder="Введите значение"
                            autoComplete="off"
                            style={{width: '100%'}}
                        />
                    </Form.Item>
                    <Form.Item
                        name="hasInvestmentProject"
                        label="Наличие у НП инвестиционных проектов"
                        style={{width: '100%'}}
                        rules={[requiredInputRule()]}
                    >
                        <CustomSelect
                            settings={{
                                placeholder: 'Выберите вариант ответа',
                                url: 'valueLists/FLEX_VALUE?sublistCode=yes_no_investment_project',
                                valuePath: 'lookupCode',
                                labelPath: 'description',
                            }}
                        />
                    </Form.Item>
                </div>
            </div>
        </div>

        <SimpleActionButton
            title="Отправить запрос"
            type="primary"
            className="send-button"
            style={{width: '100%'}}
            onClick={() => form.submit()}
        />
    </Form>
);

